"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeSystemToast = exports.openSystemToast = exports.setSystemToBeEdited = exports.closeEditSystemModal = exports.openEditSystemModal = exports.setSelectedSiteOption = exports.closeAddSystemModal = exports.openAddSystemModal = exports.saveSystemSuccess = exports.saveSystemError = exports.saveSystem = exports.getSystemComponentsError = exports.getSystemComponentsSuccess = exports.getSystemComponents = exports.getSystemsErrorReducer = exports.getSystemsSuccessReducer = exports.getSystemsReducer = exports.systemsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    systems: [],
    systemComponents: {},
    areSystemsLoading: false,
    hasErrorLoadingSystems: false,
    areSystemComponentsLoading: false,
    hasErrorLoadingSystemComponents: false,
    isSavingSystem: false,
    saveSystemSuccessMessage: "",
    saveSystemErrorMessage: "",
    isAddSystemModalOpen: false,
    selectedSiteOption: null,
    isEditSystemModalOpen: false,
    systemToBeEdited: null,
    systemToast: { isOpen: false, message: "", status: undefined },
};
exports.systemsSlice = (0, toolkit_1.createSlice)({
    name: "systems",
    initialState,
    reducers: {
        getSystemsReducer: (state) => {
            state.areSystemsLoading = true;
        },
        getSystemsSuccessReducer: (state, action) => {
            state.systems = action.payload;
            state.areSystemsLoading = false;
            state.hasErrorLoadingSystems = false;
        },
        getSystemsErrorReducer: (state) => {
            state.areSystemsLoading = false;
            state.hasErrorLoadingSystems = true;
        },
        getSystemComponents: (state) => {
            state.areSystemComponentsLoading = true;
        },
        getSystemComponentsSuccess: (state, action) => {
            state.systemComponents = action.payload;
            state.areSystemComponentsLoading = false;
        },
        getSystemComponentsError: (state) => {
            state.areSystemComponentsLoading = false;
            state.hasErrorLoadingSystemComponents = true;
        },
        saveSystem: (state) => {
            state.isSavingSystem = true;
            state.saveSystemSuccessMessage = "";
            state.saveSystemErrorMessage = "";
        },
        saveSystemSuccess: (state) => {
            state.isSavingSystem = false;
            state.saveSystemSuccessMessage = "System saved successfully";
        },
        saveSystemError: (state) => {
            state.isSavingSystem = false;
            state.saveSystemSuccessMessage = "Error creating System";
        },
        openAddSystemModal: (state) => {
            state.isAddSystemModalOpen = true;
        },
        closeAddSystemModal: (state) => {
            state.isAddSystemModalOpen = false;
        },
        setSelectedSiteOption: (state, action) => {
            state.selectedSiteOption = action.payload;
        },
        openEditSystemModal: (state) => {
            state.isEditSystemModalOpen = true;
        },
        closeEditSystemModal: (state) => {
            state.isEditSystemModalOpen = false;
        },
        setSystemToBeEdited: (state, action) => {
            state.systemToBeEdited = action.payload;
        },
        openSystemToast: (state, action) => {
            state.systemToast.isOpen = true;
            state.systemToast.status = action.payload.status;
            state.systemToast.message = action.payload.message;
        },
        closeSystemToast: (state) => {
            state.systemToast.isOpen = false;
            state.systemToast.status = undefined;
            state.systemToast.message = "";
        },
    },
});
_a = exports.systemsSlice.actions, exports.getSystemsReducer = _a.getSystemsReducer, exports.getSystemsSuccessReducer = _a.getSystemsSuccessReducer, exports.getSystemsErrorReducer = _a.getSystemsErrorReducer, exports.getSystemComponents = _a.getSystemComponents, exports.getSystemComponentsSuccess = _a.getSystemComponentsSuccess, exports.getSystemComponentsError = _a.getSystemComponentsError, exports.saveSystem = _a.saveSystem, exports.saveSystemError = _a.saveSystemError, exports.saveSystemSuccess = _a.saveSystemSuccess, exports.openAddSystemModal = _a.openAddSystemModal, exports.closeAddSystemModal = _a.closeAddSystemModal, exports.setSelectedSiteOption = _a.setSelectedSiteOption, exports.openEditSystemModal = _a.openEditSystemModal, exports.closeEditSystemModal = _a.closeEditSystemModal, exports.setSystemToBeEdited = _a.setSystemToBeEdited, exports.openSystemToast = _a.openSystemToast, exports.closeSystemToast = _a.closeSystemToast;
exports.default = exports.systemsSlice.reducer;
